import dayjs from 'dayjs';
import { blobToBase64 } from '../transform';

export const isAllValue = (value) =>
  value?.toLowerCase() === 'all' ? '' : value;

export const filterBuilder = (filter) => {
  const startDate = filter[0];
  const endDate = filter[1];

  const result = {
    ...filter,
    ...startDate,
    ...endDate,
    regional: isAllValue(filter?.regional),
    provinceId: isAllValue(filter?.provinceId),
    cityId: isAllValue(filter?.cityId),
    districtId: isAllValue(filter?.districtId),
    villageId: isAllValue(filter?.villageId),
  };

  delete result?.registrationDate;

  return result;
};

export const editFormPayload = (values) => {
  const {
    registrationId,
    nationalityId,
    storeName,
    ownerName,
    phoneNumber,
    storePhoneNumber,
    email,
    zipcode,
    street,
    coordinate,
    provinceId,
    cityId,
    districtId,
    villageId,
    bankName,
    accountNumber,
    accountName,
    midLA
  } = values;

  return {
    registrationId,
    nationalityId,
    storeName,
    ownerName,
    phoneNumber,
    storePhoneNumber,
    email,
    zipCode: zipcode,
    street,
    coordinate,
    provinceId,
    cityId,
    districtId,
    villageId,
    bank: {
      bankName,
      accountNumber,
      accountName,
    },
    mid: midLA,
  };
};

export const suspendFormPayload = async ({ values, withPeriod }) => {
  const { reason, photo: image, startDate, endDate } = values;
  let result = { reason };

  if (image?.url) {
    const blob = await fetch(image?.url).then((res) => res.blob());
    result.photo = await blobToBase64(blob);
  }
  if (withPeriod) {
    result.startDate = dayjs(startDate).format('YYYY-MM-DD');
    result.endDate = dayjs(endDate).format('YYYY-MM-DD');
  }

  return result;
};
